import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCurrentUser } from '../services/api';
import { logout } from '../utils/auth';
import { LOCALES } from '../i18n/constants';
import { useI18n } from '../i18n/I18nContext';
import styles from './Navbar.module.css';

function Navbar() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { locale, setLocale, t } = useI18n();

  useEffect(() => {
    loadUserInfo();
  }, []);

  const loadUserInfo = async () => {
    try {
      const response = await getCurrentUser();
      setUser(response.data);
    } catch (err) {
      console.error('載入用戶資訊失敗:', err);
      if (err.response?.status === 401) {
        logout();
      }
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    logout();
  };

  const isAdmin = user?.role === 'admin';

  return (
    <div className={styles.navbar}>
      <div className={styles.navbarLeft}>
        <h1>{t('navbar.title')}</h1>
      </div>
      <div className={styles.navbarRight}>
        {!loading && user && (
          <>
            <div className={styles.userInfo}>
              <span className={styles.userRole}>
                {user.role === 'admin' ? t('navbar.role_admin') : t('navbar.role_user')}
              </span>
              <span className={styles.userUsername}>{user.username}</span>
            </div>
            {isAdmin && (
              <>
                <button
                  type="button"
                  onClick={() => navigate('/chat')}
                  className={styles.navLinkButton}
                >
                  {t('navbar.back_to_chat')}
                </button>
                <button
                  type="button"
                  onClick={() => navigate('/users')}
                  className={styles.navLinkButton}
                >
                  {t('navbar.user_management')}
                </button>
                <button
                  type="button"
                  onClick={() => navigate('/settings')}
                  className={styles.navLinkButton}
                >
                  {t('navbar.system_settings')}
                </button>
              </>
            )}
            <label className={styles.languageSelectWrap}>
              <select
                className={styles.languageSelect}
                value={locale}
                onChange={(e) => setLocale(e.target.value)}
                aria-label={t('navbar.language_select')}
              >
                {LOCALES.map((code) => (
                  <option key={code} value={code}>
                    {code === 'ja' ? t('navbar.lang_ja') : t('navbar.lang_zh_tw')}
                  </option>
                ))}
              </select>
            </label>
            <button onClick={handleLogout} className={styles.logoutButton}>
              {t('navbar.logout')}
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default Navbar;
